import React, {Component} from 'react';
import styled from 'styled-components';

class InputBlock extends Component {
    render() {
        return (
            <div className={this.props.className}>
                {this.props.children}
            </div>
        );
    }
}

export default styled(InputBlock)`
    margin-bottom: 20px;
    &:last-child{
      margin-bottom: 0;
    }
`;